// Personal Protective Equipment
export const PERSONAL_PROTECTIVE_EQUIPMENT = '/personal_protective_equipment';
export const GET_PERSONAL_PROTECTIVE_EQUIPMENT =
	'/personal_protective_equipment/';
export const GET_PERSONAL_PROTECTIVE_EQUIPMENT_QUERY =
	'/personal_protective_equipment/query';
export const DELETE_PERSONAL_PROTECTIVE_EQUIPMENT =
	'/personal_protective_equipment';
export const ADD_PERSONAL_PROTECTIVE_EQUIPMENT =
	'/personal_protective_equipment/';
export const UPDATE_PERSONAL_PROTECTIVE_EQUIPMENT =
	'/personal_protective_equipment';
export const PERSONAL_PROTECTIVE_EQUIPMENT_CANCELLED =
	'/personal_protective_equipment/cancelled/';
export const PERSONAL_PROTECTIVE_EQUIPMENT_DELIVERED =
	'/personal_protective_equipment/delivered/';
export const PERSONAL_PROTECTIVE_EQUIPMENT_PICKED =
	'/personal_protective_equipment/picked/';

export const PERSONAL_PROTECTIVE_EQUIPMENT_STATUS =
	'/personal_protective_equipment_status/';
export const PERSONAL_PROTECTIVE_EQUIPMENT_STATUS_BY_CODE =
	'/personal_protective_equipment_status/code/';
export const PERSONAL_PROTECTIVE_EQUIPMENT_REASON =
	'/personal_protective_equipment_reason/';

export const GET_DASHBOARD_STATUS =
	'/personal_protective_equipment/dashboard/status';
export const GET_DASHBOARD_REASON =
	'/personal_protective_equipment/dashboard/reason';
export const GET_DASHBOARD_ESTABLISHMENT =
	'/personal_protective_equipment/dashboard/establishment';
export const GET_DASHBOARD_COMPANY =
	'/personal_protective_equipment/dashboard/company';
export const GET_DASHBOARD_ASSIGNED_ITEMS =
	'/personal_protective_equipment/dashboard/assigned/items';

export const GET_CONTROL_PERSON_ASSIGNED_ITEMS =
	'/personal_protective_equipment/person/assigned/items';
export const GET_CONTROL_PERSON_ASSIGNED_ITEMS_QUERY =
	'/personal_protective_equipment/person/assigned/items/query';
export const GET_CONTROL_PERSON_ASSIGNED_ITEMS_ALL =
	'/personal_protective_equipment/person/assigned/items/all';
export const GET_PERSON_ASSIGNMENTS_QUERY =
	'/personal_protective_equipment/person/assignments/query';
export const GET_PERSON_ASSIGNMENTS_ITEMS_QUERY =
	'/personal_protective_equipment/person/assignments/items/query';
export const GET_CONTROL_WAREHOUSE_ASSIGNED_ITEMS =
	'/personal_protective_equipment/warehouse/assigned/items';
export const GET_CONTROL_WAREHOUSE_ASSIGNED_ITEMS_QUERY =
	'/personal_protective_equipment/warehouse/assigned/items/query';

// Warehouse
export const WAREHOUSE = '/warehouse';
export const WAREHOUSE_BY_ESTABLISHMENT = '/warehouse/establishment';
export const GET_WAREHOUSES = '/warehouse/';
export const DELETE_WAREHOUSE = '/warehouse';
export const ADD_WAREHOUSE = '/warehouse/';
export const UPDATE_WAREHOUSE = '/warehouse';

export const SYNCHRONIZE_WAREHOUSE = '/warehouse/synchronize';

// Warehouse Transfer
export const WAREHOUSE_TRANSFER = '/warehouse_transfer';
export const GET_WAREHOUSE_TRANSFERS = '/warehouse_transfer/';
export const DELETE_WAREHOUSE_TRANSFER = '/warehouse_transfer';
export const ADD_WAREHOUSE_TRANSFER = '/warehouse_transfer/';
export const UPDATE_WAREHOUSE_TRANSFER = '/warehouse_transfer';

// Item Group
export const ITEM_GROUP = '/item_group';
export const GET_ITEM_GROUPS = '/item_group/';
export const GET_ITEM_GROUPS_QUERY = '/item_group/query';
export const DELETE_ITEM_GROUP = '/item_group';
export const ADD_ITEM_GROUP = '/item_group/';
export const UPDATE_ITEM_GROUP = '/item_group';

// Warehouse Item
export const WAREHOUSE_ITEM = '/warehouse/item';
export const GET_WAREHOUSE_ITEMS = '/warehouse/item/';
export const GET_WAREHOUSE_ITEMS_QUERY = '/warehouse/item/query';
export const DELETE_WAREHOUSE_ITEM = '/warehouse/item';
export const ADD_WAREHOUSE_ITEM = '/warehouse/item/';
export const UPDATE_WAREHOUSE_ITEM = '/warehouse/item';
export const CHECK_WAREHOUSE_ITEM_EXISTS = '/warehouse/item/exists/';
export const WAREHOUSE_ITEM_RESERVE = '/warehouse/item/reserve/';
export const WAREHOUSE_ITEM_DELIVER = '/warehouse/item/deliver/';
export const WAREHOUSE_ITEM_RETURN = '/warehouse/item/return/';
export const WAREHOUSE_ITEM_RECEIVE = '/warehouse/item/receive/';
export const WAREHOUSE_ITEM_RELEASE = '/warehouse/item/release/';
export const WAREHOUSE_ITEM_DELIVER_STOCK_CHECK =
	'/warehouse/item/deliver/stock_check';

export const TRANSFER_WAREHOUSE_ITEM = '/warehouse/item/transfer';

// Warehouse item transfer
export const WAREHOUSE_ITEM_TRANSFER = '/warehouse_transfer/item';
export const GET_WAREHOUSE_ITEM_TRANSFERS = '/warehouse_transfer/item/';
export const DELETE_WAREHOUSE_ITEM_TRANSFER = '/warehouse_transfer/item';
export const ADD_WAREHOUSE_ITEM_TRANSFER = '/warehouse_transfer/item/';
export const UPDATE_WAREHOUSE_ITEM_TRANSFER = '/warehouse_transfer/item';
export const TRANSFER_WAREHOUSE_ITEM_TRANSFER =
	'/warehouse_transfer/item/transfer/';
export const TRANSFER_WAREHOUSE_ITEM_TRANSFER_RECEPTION =
	'/warehouse_transfer/item/transfer/reception';
export const GET_WAREHOUSE_ITEM_TRANSFER_QUERY =
	'/warehouse_transfer/item/query';

// Warehouse Category
export const WAREHOUSE_CATEGORY = '/warehouse/category';
export const GET_WAREHOUSE_CATEGORIES = '/warehouse/category/';
export const DELETE_WAREHOUSE_CATEGORY = '/warehouse/category';
export const ADD_WAREHOUSE_CATEGORY = '/warehouse/category/';
export const UPDATE_WAREHOUSE_CATEGORY = '/warehouse/category';
export const CHECK_WAREHOUSE_CATEGORY_EXISTS = '/warehouse/category/exists/';

// Warehouse Category
export const WAREHOUSE_GROUP = '/warehouse/group';
export const GET_WAREHOUSE_GROUP = '/warehouse/group/';
export const DELETE_WAREHOUSE_GROUP = '/warehouse/group';
export const ADD_WAREHOUSE_GROUP = '/warehouse/group/';
export const UPDATE_WAREHOUSE_GROUP = '/warehouse/group';
export const CHECK_WAREHOUSE_GROUP_EXISTS = '/warehouse/group/exists/';

// Warehouse Type
export const WAREHOUSE_TYPE = '/warehouse/type';
export const GET_WAREHOUSE_TYPE = '/warehouse/type/';
export const DELETE_WAREHOUSE_TYPE = '/warehouse/type';
export const ADD_WAREHOUSE_TYPE = '/warehouse/type/';
export const UPDATE_WAREHOUSE_TYPE = '/warehouse/type';

// DTE
export const CREATE_DTE = '/dte/';
export const READ_DTE_FACELE = '/dte/facele';
export const DTE_TOKEN = '/token';

// Position
export const POSITION = '/position';
export const GET_POSITION = '/position/';
export const DELETE_POSITION = '/position';
export const ADD_POSITION = '/position/';
export const UPDATE_POSITION = '/position';

// Dashboard
export const GET_COST_PPE_BY_ESTABLISHMENT = '/personal_protective_equipment/dashboard/ppe/costs-ppe-by-establishment';